import { CloseOutlined, CopyAllOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { BooleanInput, TextInput, useRefresh } from "react-admin";
import { useWatch } from "react-hook-form";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parsePhone from "../unit/inputFormat/parsePhone";
import useNotify from "../unit/useNotify";
import CustomDialogTitle from "../unit/CustomDialogTitle";
import { set } from "lodash";
const EmployerLink = ({ ...props }) => {
  const id = props.id;
  const [employerLink, setEmployerLink] = React.useState("");
  const { success } = useNotify();
  const handleClick = () => {
    let reqUrl = "general/employerlink";
    sendRequest(reqUrl, { id: id }).then((response) => {
      if (response) {
        setEmployerLink(response?.url);
      }
    });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(employerLink);
    success("Link copied to clipboard");
  };
  return (
    <Box>
      <TextField
        id="outlined-basic"
        label="Employer URL"
        variant="outlined"
        value={employerLink}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate URL"}
                onClick={handleClick}
                edge="end"
              >
                <RefreshIcon />
              </IconButton>
              <IconButton
                aria-label={"Copy URL"}
                onClick={handleCopy}
                edge="end"
                sx={{ marginLeft: "20px" }}
              >
                <CopyAllOutlined />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const EmployerAdd = (props: any) => {
  const refresh = useRefresh();
  const methods = useForm();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(0);
  const [showApplicationFee, setShowApplicationFee] = React.useState(true);
  const [showLoanAmount, setShowLoanAmount] = React.useState(false);
  const [showCounselors, setShowCounselors] = React.useState(false);
  // const sUniqueApplicationFee = useWatch({ name: "sUniqueApplicationFee" });
  // const sUniqueLoanMax = useWatch({ name: "sUniqueLoanMax" });
  const [sUniqueApplicationFee, setSUniqueApplicationFee] =
    React.useState(false);
  const [sUniqueLoanMax, setSUniqueLoanMax] = React.useState(false);
  const [selectProduct, setSelectProduct] = React.useState<any[]>([]);
  const [selectCunselor, setSelectCounselor] = React.useState<any[]>([]);
  const [productCounselors, setProductCounselors] = React.useState<any[]>([]);
  React.useEffect(() => {
    const reqUrl = "productCounselors";
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: 0 });
      if (responseData) {
        setProductCounselors(responseData);
      }
    };
    fetchData();
  }, []);

  const [allExperts, setAllExperts] = React.useState<any[]>([]);
  React.useEffect(() => {
    const reqUrl = "allExperts";
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: 0 });
      if (responseData) {
        setAllExperts(responseData);
      }
    };
    fetchData();
  }, []);

  const [employerProudcts, setEmployerProducts] = React.useState<any[]>([]);
  React.useEffect(() => {
    const reqUrl = "employersProducts";
    const fetchData = async () => {
      const responseData = await sendRequest(reqUrl, { id: 0 });
      if (responseData) {
        setEmployerProducts(responseData);
      }
    };
    fetchData();
  }, []);

  const handleSetSelectProductOrCounselor = (
    name: string,
    action: string,
    id: number
  ) => {
    if (name == "products") {
      if (action == "add") {
        setSelectProduct([...selectProduct, id]);
      } else if (action == "remove") {
        setSelectProduct(selectProduct.filter((item: any) => item !== id));
      }
    } else if (name == "counselors") {
      if (action == "add") {
        setSelectCounselor([...selectCunselor, id]);
      } else if (action == "remove") {
        setSelectCounselor(selectCunselor.filter((item: any) => item !== id));
      }
    }
  };
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  React.useEffect(() => {
    if (sUniqueApplicationFee) {
      setShowApplicationFee(true);
    } else {
      setShowApplicationFee(false);
    }
  }, [sUniqueApplicationFee]);

  React.useEffect(() => {
    if (sUniqueLoanMax) {
      setShowLoanAmount(true);
    } else {
      setShowLoanAmount(false);
    }
  }, [sUniqueLoanMax]);

  // start link product
  const handelShowCounselor = () => {
    //get all checked product ids
    let productIds = [];
  };
  const CounselorLink = ({ ...props }) => {
    const selectedExpert = props.selectedExpert;
    const selectedProduct = props.selectedProduct;

    let pcounselor: any[] = [];
    selectedProduct.map(async (pid: any) => {
      // var pcounselor2 = productCounselors[pid];
      if (productCounselors) {
        var pcounselor2 = productCounselors?.find(
          (item: any) => item.id == pid
        );
        console.log("pcounselor2===>", pcounselor2);
        if (pcounselor2?.counselorCompanyList?.length > 0) {
          pcounselor2?.counselorCompanyList.map((counselor: any) => {
            pcounselor.push(counselor);
          });
        }
      }
    });

    const CounselorLine = (props: any) => {
      const expert = props.expert;
      const defaultChecked = props.defaultChecked;
      const [cchecked, setCchecked] = React.useState(defaultChecked);
      return (
        <Typography key={expert.id} sx={{ mb: "10px" }}>
          <input
            type="checkbox"
            checked={cchecked}
            value={expert.id + `-` + expert.iAgencyId}
            className={
              "employer_add_select_expert counselor_" + expert.iAgencyId
            }
            onChange={(e) => {
              setCchecked(e.target.checked);
            }}
          />
          &nbsp;&nbsp;&nbsp;{expert.sName} - {expert.sFname} {expert.sLname}
        </Typography>
      );
    };
    return (
      <Box>
        {allExperts.map(
          (expert: any) =>
            pcounselor.includes(expert.iAgencyId) && (
              <CounselorLine expert={expert} defaultChecked={false} />
            )
        )}
      </Box>
    );
  };
  const ProductLine = (props: any) => {
    const product = props.product;
    const [pchecked, setPchecked] = React.useState(props.checked);

    return (
      <>
        <Typography
          sx={{ color: product.iStatus ? "black" : "#ddd", mb: "10px" }}
        >
          <input
            type="checkbox"
            checked={pchecked}
            value={product.id}
            className="employer_add_select_product"
            onChange={(e) => {
              setPchecked(e.target.checked);
              props?.cb(product.id, e.target.checked);
            }}
          />
          {/* {product.id} */}
          &nbsp;&nbsp;&nbsp;{product.sProductName}
        </Typography>
      </>
    );
  };
  const CustomSelectProduct = (props: any) => {
    // const record = useRecordContext();
    let record: { empProducts?: any[]; experts?: any[]; productList?: any[] } =
      {};
    record.productList = employerProudcts;
    let selectArray = record?.empProducts;

    let experts = record?.experts; //employer linked experts
    // let selectIdArray: string[] = [];
    let defaultSelectPids: string[] = [];
    if (selectArray) {
      selectArray.forEach((product: any) => {
        defaultSelectPids.push(product.id);
      });
    }

    const [selectIdArray, setSelectIdArray] =
      React.useState<any[]>(defaultSelectPids);
    let productNums = 0;

    const changeSelectProducts = (id: number, checked: boolean) => {
      if (checked) {
        setSelectIdArray([...selectIdArray, id]);
      } else {
        setSelectIdArray(selectIdArray.filter((item: any) => item !== id));
      }
    };
    // console.log("selectIdArray is ===>", selectIdArray);
    if (record?.productList) {
      return (
        <>
          <Box>
            <Typography
              variant="h3"
              sx={{ fontWeight: "bold", color: "grey", marginBottom: "15px" }}
            >
              Select Products
            </Typography>
            {record?.productList.map((product: any) => (
              <li key={product.id} style={{ listStyle: "none" }}>
                <ProductLine
                  product={product}
                  checked={selectIdArray.includes(product.id)}
                  cb={changeSelectProducts}
                />
              </li>
            ))}
          </Box>
          {selectIdArray?.length > 0 && (
            <Box sx={{ marginTop: "30px" }}>
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold", color: "grey", marginBottom: "15px" }}
              >
                Financial Counselor
              </Typography>
              <CounselorLink
                selectedExpert={{}}
                selectedProduct={selectIdArray}
              />
            </Box>
          )}
        </>
      );
    } else {
      return <></>;
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };
  // end link product
  return (
    <>
      <Button
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Employer
      </Button>
      <FormProvider {...methods}>
        <Dialog
          className="employer_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            component: "form",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());
              if (formJson.sUniqueLoanMax == "on") {
                formJson.sUniqueLoanMax = "Yes";
              }
              if (formJson.guarantee == "on") {
                formJson.guarantee = "Yes";
              }
              if (formJson.employer_verification == "on") {
                formJson.employer_verification = "Yes";
              }
              if (formJson.sUniqueApplicationFee == "on") {
                formJson.sUniqueApplicationFee = "Yes";
              }
              let select_products: any[] = [];
              //find .employer_add_dialog select
              let select = document.querySelectorAll(
                ".employer_add_select_product"
              );
              select.forEach((element) => {
                if ((element as HTMLInputElement)?.checked) {
                  select_products.push((element as HTMLInputElement)?.value);
                }
              });
              formJson.productId = select_products.join(",");

              // find .employer_select_expert  select
              let select_expert = document.querySelectorAll(
                ".employer_add_select_expert"
              );
              let select_expert_arr: any[] = [];
              select_expert.forEach((element) => {
                if ((element as HTMLInputElement)?.checked) {
                  select_expert_arr.push((element as HTMLInputElement)?.value);
                }
              });
              formJson.expert = select_expert_arr.join(",");
              if (formJson.sStatus == "1" && formJson.productId != "") {
                formJson.iComplete = 1;
              } else {
                formJson.iComplete = 0;
              }
              console.log("formJson===>", formJson);
              // infoNotify("development in progress");

              const reqUrl = `employers/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });
              // console.log(response.data);
              if (response && response.code == "200") {
                successNotify("Data saved successfully");
                handleClose();
              } else {
                errorNotify(response?.message || "Data not saved!");
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              borderBottom: "1px solid #e5e5e5",
              mb: 2,
            }}
          >
            <CustomDialogTitle title={`Add Employer`} />
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                width: "100%",
                pt: 1,
                // height: "50vh",
                // maxHeight: "50vh",
              }}
            >
              <>
                <Box
                  sx={{
                    display: activeTab === 0 ? "block" : "none",
                    pt: 0,
                    pb: 0,
                  }}
                >
                  <HmTextInput
                    source="name"
                    label="Organization Name"
                    required={true}
                  />
                  {/* Employer Address, Street1, City, State, Zip */}
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      mt: "0px",
                      "& .MuiGrid-item": {
                        pt: 0,
                      },
                    }}
                  >
                    <Grid item xs={8}>
                      <HmTextInput
                        source="address"
                        label="Street"
                        required={true}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <HmTextInput
                        source="address2"
                        label="Street2"
                        required={false}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <HmTextInput source="city" label="City" required={true} />
                    </Grid>
                    <Grid item xs={4}>
                      <HmTextInput
                        source="state"
                        label="State"
                        required={true}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <HmTextInput
                        source="zipcode"
                        label="Zip"
                        required={true}
                      />
                    </Grid>
                  </Grid>

                  {/* Contact Name */}
                  <HmTextInput
                    source="contact_name"
                    label="Contact Name"
                    required={true}
                  />
                  {/* Contact Email */}
                  <HmTextInput
                    source="contact_email"
                    label="Contact Email"
                    required={true}
                  />
                  {/* Contact Phone */}
                  <HmTextInput
                    source="contact_phone"
                    label="Contact Phone"
                    required={true}
                    format={formatPhone}
                    parse={parsePhone}
                  />
                  {/* <OneZeroInput
                  source="sStatus"
                  name="sStatus"
                  defaultValue={false}
                  label="Employer Status"
                /> */}
                </Box>

                <Box
                  sx={{
                    display: activeTab === 1 ? "block" : "none",
                    pt: 2,
                    pb: 2,
                  }}
                >
                  {/* Application Fee, checkbox */}

                  <BooleanInput
                    source="iApplicationFee"
                    name="sUniqueApplicationFee"
                    label="Set unique application fee"
                    defaultValue={false}
                    onChange={(e) => {
                      setSUniqueApplicationFee(e.target.checked ? true : false);
                      setShowApplicationFee(e.target.checked ? true : false);
                    }}
                  />
                  {showApplicationFee && (
                    <TextInput
                      source="application_fee"
                      name="application_fee"
                      variant="outlined"
                      label="Application Fee Amount"
                    />
                  )}

                  {/* Employer Verification, Yes or No */}
                  <BooleanInput
                    source="sVerification"
                    name="employer_verification"
                    label="Require verification"
                    defaultValue={false}
                  />
                  {/* Guarantee, Yes or No */}
                  <BooleanInput
                    source="sGuaranteeType"
                    name="guarantee"
                    label="Require guarantee"
                    defaultValue={false}
                  />
                  {/* Loan Amount Maximum, check box, if yes, show amount input, if no ,hide amount input */}
                  <BooleanInput
                    source="sUniqueLoanMax"
                    name="sUniqueLoanMax"
                    label="Set unique maximum loan amount"
                    defaultValue={false}
                    onChange={(e) => {
                      setSUniqueLoanMax(e.target.checked ? true : false);
                      setShowLoanAmount(e.target.checked ? true : false);
                    }}
                  />
                  {showLoanAmount && (
                    <TextInput
                      source="iLoanLimit"
                      name="loan_amount_maximum"
                      variant="outlined"
                      label="Loan Amount Maximum"
                    />
                  )}
                </Box>

                <Box
                  sx={{
                    display: activeTab === 2 ? "block" : "none",
                    pt: 2,
                    pb: 2,
                  }}
                  className="employer_product_section"
                >
                  <CustomSelectProduct
                    source="productList"
                    // cb={handleSetSelectProductOrCounselor}
                  />
                </Box>
                {/* <Box
                  sx={{
                    display: activeTab === 3 ? "block" : "none",
                    pt: 2,
                    pb: 2,
                  }}
                >
                  {id && <EmployerLink id={id} />}
                </Box> */}
              </>
            </Box>
          </DialogContent>
          <DialogActions>
            <CustomButtonSubmit label="Add" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default EmployerAdd;
